import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { ProgressBar } from 'primereact/progressbar';
import { Title } from 'components/Title';

export default function CollectionPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="CollectionPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('collection')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <section className="page-section mb-3" >
                    <div className="container-fluid">
                        <div className="grid ">
                            <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                <div className="">
                                    <DataSource   apiPath="components_data/option_agent_target" firstRecord={true} showLoading={false}>
                                        {
                                        ({ response, loading, reload }) => 
                                        <>
                                        <div >
                                            <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                <div className="flex align-items-center gap-3">
                                                    <div style={{width:'auto'}}>
                                                        <Avatar icon="pi pi-user" size="large" className="bg-primary text-white" />
                                                        </div>
                                                        <div>
                                                            <div className="font-medium text-lg">Today Target</div>
                                                            {loading && 
                                                            <div className="p-2">
                                                                <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                            </div>
                                                            }
                                                            {response && 
                                                            <div className="font-bold"> {JSON.stringify(response.target)}</div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                        <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                            }
                                        </DataSource>
                                    </div>
                                </div>
                                <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                    <div className="">
                                        <DataSource   apiPath="components_data/option_agent_collected" firstRecord={true} showLoading={false}>
                                            {
                                            ({ response, loading, reload }) => 
                                            <>
                                            <div >
                                                <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                    <div className="flex align-items-center gap-3">
                                                        <div style={{width:'auto'}}>
                                                            <Avatar icon="pi pi-credit-card" size="large" className="bg-primary text-white" />
                                                            </div>
                                                            <div>
                                                                <div className="font-medium text-lg">Today Collected</div>
                                                                {loading && 
                                                                <div className="p-2">
                                                                    <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                </div>
                                                                }
                                                                {response && 
                                                                <div className="font-bold">
                                                                    {Number(response.collected).toLocaleString()}
                                                                </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                            <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                        </div>
                                                    </div>
                                                </div>
                                                </>
                                                }
                                            </DataSource>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                        <div className="">
                                            <DataSource   apiPath="components_data/option_agent_pending" firstRecord={true} showLoading={false}>
                                                {
                                                ({ response, loading, reload }) => 
                                                <>
                                                <div >
                                                    <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                        <div className="flex align-items-center gap-3">
                                                            <div style={{width:'auto'}}>
                                                                <Avatar icon="pi pi-users" size="large" className="bg-primary text-white" />
                                                                </div>
                                                                <div>
                                                                    <div className="font-medium text-lg">Pending Amount</div>
                                                                    {loading && 
                                                                    <div className="p-2">
                                                                        <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                    </div>
                                                                    }
                                                                    {response && 
                                                                    <div className="font-bold">
                                                                        {Number(response.pending).toLocaleString()}
                                                                    </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                                <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                            <div className="">
                                                <DataSource   apiPath="components_data/option_agent_overdue" firstRecord={true} showLoading={false}>
                                                    {
                                                    ({ response, loading, reload }) => 
                                                    <>
                                                    <div >
                                                        <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                            <div className="flex align-items-center gap-3">
                                                                <div style={{width:'auto'}}>
                                                                    <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                                    </div>
                                                                    <div>
                                                                        <div className="font-medium text-lg">Overdue Cases</div>
                                                                        {loading && 
                                                                        <div className="p-2">
                                                                            <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                        </div>
                                                                        }
                                                                        {response && 
                                                                        <div className="font-bold">
                                                                            {Number(response.overdue).toLocaleString()}
                                                                        </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                                    <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </>
                                                        }
                                                    </DataSource>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                                <div className="">
                                                    <DataSource   apiPath="components_data/option_agent_visit" firstRecord={true} showLoading={false}>
                                                        {
                                                        ({ response, loading, reload }) => 
                                                        <>
                                                        <div >
                                                            <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                                <div className="flex align-items-center gap-3">
                                                                    <div style={{width:'auto'}}>
                                                                        <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                                        </div>
                                                                        <div>
                                                                            <div className="font-medium text-lg">Accounts to Visit</div>
                                                                            {loading && 
                                                                            <div className="p-2">
                                                                                <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                            </div>
                                                                            }
                                                                            {response && 
                                                                            <div className="font-bold">
                                                                                {Number(response.visit).toLocaleString()}
                                                                            </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                                        <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            </>
                                                            }
                                                        </DataSource>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
		</main>
	);
}
